import { render, staticRenderFns } from "./HeaderSide.vue?vue&type=template&id=0fd318de&scoped=true&lang=pug"
import script from "./HeaderSide.vue?vue&type=script&lang=js"
export * from "./HeaderSide.vue?vue&type=script&lang=js"
import style0 from "./HeaderSide.vue?vue&type=style&index=0&id=0fd318de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd318de",
  null
  
)

export default component.exports